(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsDetailController', TabActionsDetailController);

    TabActionsDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabActionsDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabActions = entity;

        vm.tabActions.$promise.then(function () {
            vm.arguments = JSON.parse(vm.tabActions.argumentsSchema);
            if(vm.arguments)
                vm.arguments = vm.arguments.properties;
        });

        var unsubscribe = $rootScope.$on('jotApp:tabActionsUpdate', function(event, result) {
            vm.tabActions = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
